import React from "react";
import classNames from "classnames";
import CustomLink from "../../elements/CustomLink";

const FooterNav = ({ className, ...props }) => {
  const classes = classNames("footer-nav", className);

  return (
    <nav {...props} className={classes}>
      <ul className="list-reset">
        <li>
          <CustomLink to="/about">About Us</CustomLink>
        </li>
        <li>
          <CustomLink to="/privacy-policy">Privacy Policy</CustomLink>
        </li>
        <li>
          <CustomLink to="/terms-of-service">Terms of Service</CustomLink>
        </li>
        <li>
          <CustomLink to="/data-deletion">Data Deletion</CustomLink>
        </li>
        <li>
          <CustomLink to="/rules">Rules</CustomLink>
        </li>
        <li>
          <CustomLink to="/support">Support</CustomLink>
        </li>
      </ul>
    </nav>
  );
};

export default FooterNav;
